import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import SectionHeading from "@/components/SectionHeading";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useLang();
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="faq-page" className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <SectionHeading overline={t("faq.overline")} title={t("faq.title")} />
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-line">
              <AccordionTrigger className="font-serif text-xl text-petrol text-left hover:no-underline py-6">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
